import React, { useEffect, useState } from "react";
import ResumoPedidos from "app/componentes/ResumoPedidos";
import { SelectCaixa } from "app/componentes/selectCaixa";
import { checarCotacaoPorPedido } from "services/api";
import { BtnVoltarHome } from "app/componentes/BtnVoltarHome";
import "../../../styles/rate.css";

export type Dinheiro = { moeda: string; valor: number };
export type CaixaSnapshot = {
    id: number | string;
    cod_identificacao: string;
    descricao?: string | null;
    altura?: number | string | null;
    largura?: number | string | null;
    comprimento?: number | string | null;
    peso?: number | string | null;
    valor_total?: Dinheiro | null;
};
export type CaixaCotacao = {
    entryId: string;
    cod_identificacao: string;
    data: CaixaSnapshot;
};
export type Endereco = {
    nome: string;
    telefone: string;
    rua: string;
    numero: string;
    complemento?: string;
    cidade: string;
    estado: string;
    cep: string;
    pais: string;
    cnpjOuTaxId?: string;
};

type Props = {
    moeda: string;
    setMoeda: (v: string) => void;
    pickupDate: string;
    setPickupDate: (v: string) => void;

    serviceCode: string;
    setServiceCode: (v: string) => void;

    pedidoRef: string;
    setPedidoRef: (v: string) => void;
    setPedidoObj: (v: any) => void;
    pedidoObj?: any;

    todasCaixas: CaixaSnapshot[];
    codSelecionado: string;
    setCodSelecionado: (v: string) => void;
    cotacaoCaixas: CaixaCotacao[];
    addCaixa: () => void;
    removeCaixa: (entryId: string) => void;

    shipper?: Endereco;
    destinatario?: Endereco;

    onNext: () => void; // 👉 substitui o antigo onSubmit (agora só avança)
};

function fmtDim(x: number | string | null | undefined) {
    const n = Number(String(x ?? "").replace(",", "."));
    return Number.isFinite(n) ? n.toFixed(2) : "";
}

function itemsFromPedido(p: any): any[] {
    if (!p) return [];
    if (Array.isArray(p.itens)) return p.itens;
    if (Array.isArray(p.line_items))
        return p.line_items.map((li: any) => ({
            sku: li.sku,
            titulo: li.title || li.name,
            quantidade: li.quantity,
            preco: li.price,
            hscode: "",
        }));
    return [];
}

export default function RateStep(props: Props) {
    const {
        moeda,
        setMoeda,
        pickupDate,
        setPickupDate,
        pedidoRef,
        setPedidoRef,
        setPedidoObj,
        pedidoObj,
        serviceCode,
        setServiceCode,
        // todasCaixas,
        codSelecionado,
        setCodSelecionado,
        cotacaoCaixas,
        addCaixa,
        removeCaixa,
        // shipper,
        // destinatario,
        onNext,
    } = props;

    const [bloqueado, setBloqueado] = useState<{ has: boolean; id: number | null }>({ has: false, id: null });

    useEffect(() => {
        let alive = true;
        (async () => {
            const ref = String(pedidoRef || "").trim();
            if (!ref) { setBloqueado({ has: false, id: null }); return; }
            setChecando(true);
            try {
                const { data } = await checarCotacaoPorPedido(ref);
                if (!alive) return;
                setBloqueado({ has: !!data.hasActive, id: data.cotacaoId ?? null });
            } finally {
                if (alive) setChecando(false);
            }
        })();
        return () => { alive = false; };
    }, [pedidoRef]);

    const [pesoTotalKg, setPesoTotalKg] = useState<number | null>(null);
    const [, setChecando] = useState(false);

    return (
        <div id="page-ups">
            <div id="card-ups">
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        onNext();
                    }}
                    autoComplete="off"
                >
                    <h2>1 - Cotação</h2>

                    {/* Remetente e destinatário */}
                    {/* {(shipper || destinatario) && (
                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: 16,
                                marginBottom: 12,
                            }}
                        >
                            {shipper && (
                                <fieldset>
                                    <legend>Remetente (cadastro)</legend>
                                    <div><strong>{shipper.nome}</strong></div>
                                    <div>
                                        {shipper.rua}
                                        {shipper.numero ? `, ${shipper.numero}` : ""}
                                        {shipper.complemento ? ` - ${shipper.complemento}` : ""}
                                    </div>
                                    <div>
                                        {shipper.cidade}/{shipper.estado} • {shipper.cep} • {shipper.pais}
                                    </div>
                                </fieldset>
                            )}
                            {destinatario && (
                                <fieldset>
                                    <legend>Destinatário (pedido)</legend>
                                    <div><strong>{destinatario.nome}</strong></div>
                                    <div>
                                        {destinatario.rua}
                                        {destinatario.numero ? `, ${destinatario.numero}` : ""}
                                        {destinatario.complemento ? ` - ${destinatario.complemento}` : ""}
                                    </div>
                                    <div>
                                        {destinatario.cidade}/{destinatario.estado} • {destinatario.cep} • {destinatario.pais}
                                    </div>
                                </fieldset>
                            )}
                        </div>
                    )} */}

                    {/* Cabeçalho */}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                        <div>
                            <label>Moeda</label>
                            <select value={moeda} onChange={(e) => setMoeda(e.target.value)}>
                                <option value="USD">USD</option>
                                <option value="BRL">BRL</option>
                                <option value="EUR">EUR</option>
                                <option value="MXN">MXN</option>
                            </select>
                        </div>
                        {/* <div>
                            <label>Serviço UPS</label>
                            <select value={serviceCode} onChange={(e) => setServiceCode(e.target.value)}>
                                <option value="07">Worldwide Express (07)</option>
                                <option value="08">Worldwide Expedited (08)</option>
                                <option value="65">Saver (65)</option>
                            </select>
                        </div> */}
                        {/* <div>
                            <label>Data de coleta</label>
                            <input
                                type="date"
                                value={pickupDate}
                                onChange={(e) => setPickupDate(e.target.value)}
                            />
                        </div> */}
                    </div>

                    {/* Pedido Shopify */}
                    <div style={{ marginTop: 12 }}>
                        <label>Pedido (Shopify)</label>
                        <ResumoPedidos value={pedidoRef} onChange={setPedidoRef} onSelectPedido={setPedidoObj} />
                    </div>

                    {/* Peso total */}
                    <div style={{ marginTop: 12 }}>
                        <label>Peso total dos itens (kg)</label>
                        <input
                            type="number"
                            min={0}
                            step="0.001"
                            placeholder="ex.: 1.250"
                            value={pesoTotalKg ?? ""}
                            onChange={(e) => {
                                const v = Number(e.target.value);
                                setPesoTotalKg(v);
                                setPedidoObj((prev: any) => ({ ...(prev || {}), peso_total_kg: v }));
                            }}
                            style={{ width: 200 }}
                        />
                    </div>

                    {Array.isArray(itemsFromPedido(pedidoObj)) && itemsFromPedido(pedidoObj).length > 0 && (
                        <fieldset style={{ marginTop: 12 }}>
                            <legend>Itens do pedido — HS Code</legend>
                            <div style={{ fontSize: 12, opacity: .8, marginBottom: 6 }}>
                                Informe o HS/NCM de cada item (ex.: 6104.63.00). Se deixar em branco, usaremos “00000000”.
                            </div>

                            {/* cabeçalho */}
                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "48px 1fr 80px 160px",
                                    gap: 8,
                                    alignItems: "center",
                                    fontWeight: 600,
                                    marginBottom: 6
                                }}
                            >
                                <div>#</div>
                                <div>Descrição</div>
                                <div style={{ textAlign: "right" }}>Qtd</div>
                                <div>HS Code / NCM</div>
                            </div>

                            {/* linhas */}
                            <div style={{ display: "grid", rowGap: 10 }}>
                                {itemsFromPedido(pedidoObj).map((it, idx) => {
                                    const val = String(it.hscode ?? "");
                                    return (
                                        <div
                                            key={idx}
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "48px 1fr 80px 160px",
                                                gap: 8,
                                                alignItems: "center"
                                            }}
                                        >
                                            <div>{idx + 1}</div>
                                            <div title={it.sku || ""}>
                                                {it.titulo || it.title || it.descricao || it.sku || "Item"}
                                            </div>
                                            <div style={{ textAlign: "right" }}>
                                                {Number(it.quantidade || it.qty || 1)}
                                            </div>
                                            <div>
                                                <input
                                                    id={`hs-${idx}`}
                                                    name={`hs-${idx}`}
                                                    type="text"
                                                    inputMode="numeric"
                                                    placeholder="ex.: 6104.63.00"
                                                    autoComplete="off"
                                                    value={val}
                                                    onChange={(e) => {
                                                        const clean = e.target.value.replace(/[^\d.]/g, "").slice(0, 10);
                                                        setPedidoObj((prev: any) => {
                                                            const arr = Array.isArray(itemsFromPedido(prev)) ? itemsFromPedido(prev) : [];
                                                            const clone = arr.map((x: any, i: number) =>
                                                                i === idx ? { ...x, hscode: clean } : x
                                                            );
                                                            // garante que salvamos em 'itens'
                                                            return { ...(prev || {}), itens: clone };
                                                        });
                                                    }}
                                                    style={{ width: 150 }}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </fieldset>
                    )}

                    {/* Caixas */}
                    <fieldset style={{ marginTop: 12 }}>
                        <legend>Pacotes</legend>
                        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                            <div style={{ minWidth: 280 }}>
                                <SelectCaixa
                                    id="select-caixa"
                                    includeEmpty
                                    value={codSelecionado}
                                    onChange={setCodSelecionado}
                                />
                            </div>
                            <button
                                type="button"
                                className="botao botao--primario"
                                onClick={addCaixa}
                                disabled={!codSelecionado}
                            >
                                Adicionar
                            </button>
                        </div>

                        {cotacaoCaixas.length === 0 ? (
                            <p style={{ marginTop: 8, opacity: 0.8 }}>Nenhum pacote adicionado.</p>
                        ) : (
                            <div style={{ marginTop: 8, display: "grid", gap: 8 }}>
                                {cotacaoCaixas.map((c) => (
                                    <div key={c.entryId} style={{ border: "1px solid #ddd", padding: 8, borderRadius: 6 }}>
                                        <strong>{c.data.cod_identificacao}</strong>
                                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 8, marginTop: 6 }}>
                                            <div>Altura: {fmtDim(c.data.altura)} cm</div>
                                            <div>Largura: {fmtDim(c.data.largura)} cm</div>
                                            <div>Comprimento: {fmtDim(c.data.comprimento)} cm</div>
                                        </div>
                                        <button onClick={() => removeCaixa(c.entryId)} style={{backgroundColor: "red", color: "#fff"}}>Remover</button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </fieldset>

                    {bloqueado.has && (
                        <div style={{ marginTop: 8, padding: 8, border: "1px solid #f3c97a", background: "#fff8e1", borderRadius: 6 }}>
                            <strong>Este pedido já possui uma cotação.</strong><br />
                        </div>
                    )}

                    <div style={{ marginTop: 12 }}>
                        <button type="submit" className="botao botao--primario">
                            Próximo passo
                        </button>
                    </div>
                </form>
            </div>
            <BtnVoltarHome />
        </div>
    );
}